import { render, staticRenderFns } from "./TruckEdit.vue?vue&type=template&id=c0bb8708&scoped=true"
import script from "./TruckEdit.vue?vue&type=script&lang=js"
export * from "./TruckEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bb8708",
  null
  
)

export default component.exports